<template>
  <dialog-add
    icon="upload"
    :title="$t('bulk_upload')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
    class="tracking-bulk-upload-dialog"
  >
    <template v-slot:content>
      <forms-tracking-bulk-upload
        :on-cancel="onCancel"
        class="elevation-1"
        @saved="$emit('saved')"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({ name: 'tracking-management', query: this.$route.query });
    },
  },
};
</script>

<style>
.tracking-bulk-upload-dialog > .modal > .modal__backdrop > .modal__content {
  width: 690px;
}
</style>
